<template>
  <div style="position: relative;">
    <k-data-table :headers="headers" :items="groupList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <tr>
          <td @click.stop="open_edit_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.name }}</td>
          <td @click.stop="open_edit_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.uuid }}</td>
          <td @click.stop="open_edit_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.state }}</td>
        </tr>
      </template>
    </k-data-table>
    <action-buttons @add="open_add_group"></action-buttons>
  </div>
</template>

<script>
import ActionButtons from '@/components/ActionButtons.vue'

export default {
  components: {
    ActionButtons
  },
  props: ['type'],
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Uuid', value: 'uuid', align: 'left' },
        { text: 'State', value: 'state', align: 'left' }
      ],
      pagination: {
        sortBy: 'name',
        descending: true,
        rowsPerPage: 25
      },
    }
  },
  computed: {
    search_text () {
      return this.$store.state.search_text;
    },
    groupList () {
      var ret = Object.values(this.$store.state.all_groups);
      var search = (this.search_text || "").toLowerCase();
      if (search.length > 0) {
        ret = _.filter(ret, function(group) {
          ret = false;
          if (group.name.toLowerCase().includes(search)) ret = true;
          if (group.uuid.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }
      return ret;
    }
  },
  mounted () {
  },
  methods: {
    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    open_add_group () {
      this.$router.push("/settings/groups/new")
    },
    open_edit_group (uuid) {
      this.$router.push("/settings/groups/edit/"+uuid)
    }
  }
}
</script>
